module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', [_vm._s(_vm.msg)]), " ", (_vm.rollcallTeacherId == _vm.teacherId || _vm.cookie_login_data.jobId == 1 || _vm.cookie_login_data.jobId == 2) ? _vm._h('span', {
    staticClass: "pull-right icon-right",
    on: {
      "click": function($event) {
        _vm.popupvisebleEidtrollcall = true
      }
    }
  }, ["编辑"]) : _vm._e()]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('div', {
    staticClass: "main-page ",
    class: {
      'roll-edit': _vm.callState == 2, 'roll-get': _vm.callState == 1
    },
    staticStyle: {
      "padding-bottom": "60px"
    }
  }, [(_vm.callState == 1) ? [_vm._l((_vm.rollcallList), function(item) {
    return (item.studentList.length > 0) ? _vm._h('div', [_vm._h('span', {
      staticClass: "margin-15 block"
    }, [_vm._s(item.grade)]), " ", _vm._h('ul', {
      staticClass: "list-group-item bigger",
      on: {
        "click": function($event) {
          _vm.updateRollcallState($event)
        }
      }
    }, [_vm._l((item.studentList), function(student) {
      return _vm._h('li', {
        staticClass: "list-group"
      }, [_vm._h('div', {
        staticClass: "liner"
      }), " ", _vm._h('div', {
        staticClass: "group-link clearfix"
      }, [_vm._h('div', {
        staticClass: "img-wrap pull-left big"
      }, [_vm._h('img', {
        staticClass: "pull-left",
        attrs: {
          "src": student.imageAddress ? item.baseAcessPath + student.imageAddress : _vm.img_default,
          "width": "100%"
        }
      })]), " ", _vm._h('span', {
        staticClass: "group-txt",
        staticStyle: {
          "padding-top": "0"
        }
      }, [_vm._h('span', {
        staticClass: "block overhide"
      }, [_vm._h('cite', {
        staticClass: "font-16 pull-left"
      }, [_vm._s(student.studentName)]), " ", _vm._h('i', {
        staticClass: "img-sex",
        class: {
          'boy': student.sex == '男', 'girl': student.sex == '女'
        }
      }, [_vm._s(student.sex)])]), " ", _vm._h('cite', {
        staticClass: "gray"
      }, [_vm._s(item.grade) + _vm._s(student.className) + _vm._s(student.typeName ? '（' + student.typeName + '）' : '')]), " ", (student.callState == 1) ? _vm._h('span', {
        staticClass: "block gray"
      }, [_vm._s(student.teacherName) + " " + _vm._s(student.callTime)]) : _vm._e()]), " ", (student.callState == 1) ? _vm._h('span', {
        staticClass: "no-get"
      }, [_vm._h('a', {
        on: {
          "click": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            _vm.isHideRollcallNo = false, _vm.setStudentDialog(student, item.baseAcessPath, item.grade)
          }
        }
      }, ["未签到"])]) : _vm._e()])])
    })])]) : _vm._e()
  })] : _vm._e(), " ", (_vm.callState == 2) ? [_vm._l((_vm.rollcallList), function(item) {
    return (item.studentList.length > 0) ? _vm._h('div', [_vm._h('span', {
      staticClass: "margin-15 block"
    }, [_vm._s(item.grade)]), " ", _vm._h('ul', {
      staticClass: "list-group-item bigger"
    }, [_vm._l((item.studentList), function(student) {
      return _vm._h('li', {
        staticClass: "list-group"
      }, [_vm._h('div', {
        staticClass: "liner"
      }), " ", _vm._h('div', {
        staticClass: "group-link clearfix"
      }, [_vm._h('div', {
        staticClass: "img-wrap big pull-left"
      }, [_vm._h('img', {
        attrs: {
          "src": student.imageAddress ? item.baseAcessPath + student.imageAddress : _vm.img_default,
          "width": "100%"
        }
      })]), " ", _vm._h('span', {
        staticClass: "group-txt"
      }, [_vm._h('span', {
        staticClass: "block overhide"
      }, [_vm._h('cite', {
        staticClass: "font-16 pull-left"
      }, [_vm._s(student.studentName)]), " ", _vm._h('i', {
        staticClass: "img-sex",
        class: {
          'boy': student.sex == '男', 'girl': student.sex == '女'
        }
      }, [_vm._s(student.sex)])]), " ", _vm._h('cite', {
        staticClass: "gray"
      }, [_vm._s(item.grade) + _vm._s(student.className) + _vm._s(student.typeName ? '（' + student.typeName + '）' : '')])]), " ", " ", (student.callState == 2) ? _vm._h('span', {
        staticClass: "pull-right"
      }, [(_vm.upd_status_para.isLoading == false) ? _vm._h('a', {
        staticClass: "button-roll",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.studentDialog = student, _vm.updStatus(1)
          }
        }
      }, ["签到"]) : _vm._e()]) : _vm._e(), " ", (student.callState == 2) ? _vm._h('span', {
        staticClass: "pull-right"
      }, [(_vm.upd_status_para.isLoading == true) ? _vm._h('a', {
        staticClass: "button-roll"
      }, ["签到"]) : _vm._e()]) : _vm._e()])])
    })])]) : _vm._e()
  })] : _vm._e()]), " ", _vm._h('div', {
    staticClass: "bottom-bar"
  }, [_vm._h('div', {
    staticClass: "tabs"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('ul', {
    staticClass: "clearfix text-center font-14"
  }, [_vm._h('li', {
    staticClass: "col-xs-6",
    class: {
      'active': _vm.callState == 2
    },
    on: {
      "click": function($event) {
        _vm.callState = 2, _vm.getCallList()
      }
    }
  }, [_vm._h('span', ["未签到（" + _vm._s(_vm.wdd) + "）"])]), " ", _vm._h('li', {
    staticClass: "col-xs-6",
    class: {
      'active': _vm.callState == 1
    },
    on: {
      "click": function($event) {
        _vm.callState = 1, _vm.getCallList()
      }
    }
  }, [_vm._h('span', ["已签到（" + _vm._s(_vm.ydd) + "）"])])])])]), " ", _vm._h('mt-popup', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.popupvisebleEidtrollcall),
      expression: "popupvisebleEidtrollcall"
    }],
    attrs: {
      "position": "bottom"
    },
    domProps: {
      "value": (_vm.popupvisebleEidtrollcall)
    },
    on: {
      "input": function($event) {
        _vm.popupvisebleEidtrollcall = $event
      }
    }
  }, [_vm._h('div', {
    staticClass: "shall text-center"
  }, [_vm._h('div', {
    staticClass: "clearfix margin-15 font-10"
  }, [_vm._h('div', {
    staticClass: "col-xs-6"
  }, [_vm._h('router-link', {
    staticClass: "icon-edit icon gray",
    attrs: {
      "to": {
        'path': '/rollcall/edit/' + _vm.rollcallId
      }
    }
  }, ["修改名单"])]), " ", _vm._h('div', {
    staticClass: "col-xs-6"
  }, [_vm._h('a', {
    staticClass: "icon-del icon gray",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isHideCancelRollcall = false
      }
    }
  }, ["删除点名"])])]), " ", _vm._h('ul', {
    staticClass: "list-group-item tinny",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('span', {
    staticClass: "group-txt",
    on: {
      "click": function($event) {
        _vm.popupvisebleEidtrollcall = false
      }
    }
  }, ["取消"])])])])]), " ", (_vm.rollcallTeacherId == _vm.teacherId || _vm.cookie_login_data.jobId == 1 || _vm.cookie_login_data.jobId == 2) ? _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideCancelRollcall),
      expression: "!isHideCancelRollcall"
    }],
    staticClass: "maskdiv",
    on: {
      "click": function($event) {
        _vm.isHideCancelRollcall = true
      }
    }
  }, [_vm._h('div', {
    staticClass: "popover",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._h('div', {
    staticClass: "pop-wrap text-center"
  }, [_vm._h('p', {
    staticClass: "margin-15"
  }, ["您确定要删除本次点名吗？"]), " ", _vm._h('div', {
    staticClass: "liner margin-15"
  }), " ", _vm._h('div', {
    staticClass: "clearfix"
  }, [_vm._h('div', {
    staticClass: "col-xs-6 blue"
  }, [_vm._h('a', {
    staticClass: "blue  block",
    staticStyle: {
      "border-right": "1px solid #ddd"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updRollStatus(4)
      }
    }
  }, ["确定"])]), " ", _vm._h('div', {
    staticClass: "col-xs-6 blue"
  }, [_vm._h('a', {
    staticClass: "blue",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isHideCancelRollcall = true
      }
    }
  }, ["取消"])])])])])]) : _vm._e(), " ", (_vm.rollcallTeacherId == _vm.teacherId || _vm.cookie_login_data.jobId == 1 || _vm.cookie_login_data.jobId == 2) ? _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideOverRollcall),
      expression: "!isHideOverRollcall"
    }],
    staticClass: "maskdiv",
    on: {
      "click": function($event) {
        _vm.isHideOverRollcall = true
      }
    }
  }, [_vm._h('div', {
    staticClass: "popover",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._h('div', {
    staticClass: "pop-wrap text-center"
  }, [_vm._h('p', {
    staticClass: "margin-15"
  }, ["您确定要结束本次点名吗？"]), " ", _vm._h('div', {
    staticClass: "liner margin-15"
  }), " ", _vm._h('div', {
    staticClass: "clearfix"
  }, [_vm._h('div', {
    staticClass: "col-xs-6 blue"
  }, [_vm._h('a', {
    staticClass: "blue  block",
    staticStyle: {
      "border-right": "1px solid #ddd"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updRollStatus(3)
      }
    }
  }, ["确定"])]), " ", _vm._h('div', {
    staticClass: "col-xs-6 blue"
  }, [_vm._h('a', {
    staticClass: "blue",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isHideOverRollcall = true
      }
    }
  }, ["取消"])])])])])]) : _vm._e(), " ", " ", _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideRollcallOk),
      expression: "!isHideRollcallOk"
    }],
    staticClass: "maskdiv",
    on: {
      "cick": function($event) {
        _vm.isHideRollcallOk = true
      }
    }
  }, [_vm._h('div', {
    staticClass: "popover",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._h('div', {
    staticClass: "pop-wrap pop-parents"
  }, [_vm._h('div', {
    staticClass: "clearfix margin-x-15"
  }, [_vm._h('div', {
    staticClass: "pull-left"
  }, [_vm._h('img', {
    staticClass: "rounded-60",
    attrs: {
      "src": _vm.studentDialog.imageAddress ? _vm.studentDialog.baseAcessPath + _vm.studentDialog.imageAddress : _vm.img_default,
      "width": "60",
      "height": "60"
    }
  })]), " ", _vm._h('div', {
    staticClass: "pull-left padding-10 margin-x-15"
  }, [_vm._h('p', {
    staticClass: "font-16 clearfix"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, [_vm._s(_vm.studentDialog.studentName)]), " ", _vm._h('span', {
    staticClass: "pull-left img-sex",
    class: {
      'boy': _vm.studentDialog.sex == '男', 'girl': _vm.studentDialog.sex == '女'
    }
  })]), " ", _vm._h('p', {
    staticClass: "gray"
  }, [_vm._s(_vm.studentDialog.grade) + _vm._s(_vm.studentDialog.className) + _vm._s(_vm.studentDialog.typeName ? '（' + _vm.studentDialog.typeName + '）' : '')])])]), " ", _vm._h('p', {
    staticClass: "text-center padding-15"
  }, ["确定要更改为“ 已签到 ”吗？"]), " ", _vm._h('div', {
    staticClass: "liner margin-x-15"
  }), " ", _vm._h('div', {
    staticClass: "clearfix text-center"
  }, [_vm._h('div', {
    staticClass: "col-xs-6"
  }, [(_vm.upd_status_para.isLoading == false) ? _vm._h('a', {
    staticClass: "blue block padding-15",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updStatus(1)
      }
    }
  }, [_vm._h('span', {
    staticClass: "block",
    staticStyle: {
      "border-right": "1px solid #e3e3e3"
    }
  }, ["确定"])]) : _vm._h('a', {
    staticClass: "blue block padding-15"
  }, [_vm._h('span', {
    staticClass: "block",
    staticStyle: {
      "border-right": "1px solid #e3e3e3"
    }
  }, ["确定"])]), " "]), " ", _vm._h('div', {
    staticClass: "col-xs-6"
  }, [_vm._h('a', {
    staticClass: "blue block padding-15",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isHideRollcallOk = true
      }
    }
  }, [_vm._h('span', {
    staticClass: "block"
  }, ["取消"])])])])])])]), " ", " ", _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideRollcallNo),
      expression: "!isHideRollcallNo"
    }],
    staticClass: "maskdiv",
    on: {
      "click": function($event) {
        _vm.isHideRollcallNo = true
      }
    }
  }, [_vm._h('div', {
    staticClass: "popover",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._h('div', {
    staticClass: "pop-wrap pop-parents"
  }, [_vm._h('div', {
    staticClass: "clearfix margin-x-15"
  }, [_vm._h('div', {
    staticClass: "pull-left"
  }, [_vm._h('img', {
    staticClass: "rounded-60",
    attrs: {
      "src": _vm.studentDialog.imageAddress ? _vm.studentDialog.baseAcessPath + _vm.studentDialog.imageAddress : _vm.img_default,
      "width": "60",
      "height": "60"
    }
  })]), " ", _vm._h('div', {
    staticClass: "pull-left padding-10 margin-x-15"
  }, [_vm._h('p', {
    staticClass: "font-16 clearfix"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, [_vm._s(_vm.studentDialog.studentName)]), " ", _vm._h('span', {
    staticClass: "pull-left img-sex",
    class: {
      'boy': _vm.studentDialog.sex == '男', 'girl': _vm.studentDialog.sex == '女'
    }
  })]), " ", _vm._h('p', {
    staticClass: "gray"
  }, [_vm._s(_vm.studentDialog.grade) + _vm._s(_vm.studentDialog.className) + _vm._s(_vm.studentDialog.typeName ? '（' + _vm.studentDialog.typeName + '）' : '')])])]), " ", _vm._h('p', {
    staticClass: "text-center padding-15"
  }, ["确定要更改为“ 未签到 ”吗？"]), " ", _vm._h('div', {
    staticClass: "liner margin-x-15"
  }), " ", _vm._h('div', {
    staticClass: "clearfix text-center"
  }, [_vm._h('div', {
    staticClass: "col-xs-6"
  }, [(_vm.upd_status_para.isLoading == false) ? _vm._h('a', {
    staticClass: "blue block padding-15",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updStatus(2)
      }
    }
  }, [_vm._h('span', {
    staticClass: "block",
    staticStyle: {
      "border-right": "1px solid #e3e3e3"
    }
  }, ["确定"])]) : _vm._h('a', {
    staticClass: "blue block padding-15",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._h('span', {
    staticClass: "block",
    staticStyle: {
      "border-right": "1px solid #e3e3e3"
    }
  }, ["确定"])]), " "]), " ", _vm._h('div', {
    staticClass: "col-xs-6"
  }, [_vm._h('a', {
    staticClass: "blue block padding-15",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isHideRollcallNo = true
      }
    }
  }, [_vm._h('span', {
    staticClass: "block"
  }, ["取消"])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-1016f05c!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/rollcall/rollcallDetail.vue
// module id = 176
// module chunks = 1